/*
 * This file contains any application configuration that is not specific to
 * environments (ie. no db connections, service URLs - use the .env files for
 * those configurations).
 */
export default Object.freeze({
  SUPPORTED_LANGS: ['en', 'fr'],
  DEFAULT_LANG: 'en',
  ACCEPTED_ATTACHMENTS: [
    '.pdf',
    '.doc',
    '.docx',
    '.txt',
    '.rtf',
    '.xls',
    '.xlsx',
    '.gif',
    '.jpg',
    '.jpeg',
    '.png',
    '.bmp',
  ]
})